import maxBy from 'hs-lodash/maxBy';
import { MS_IN_A_DAY, MS_IN_A_MINUTE, TRACK_AWARD_EXPIRY_DAYS } from '../../constants/TimeConstants';
import { getServerSyncedTime } from '../../utils/TimeUtils';
import { isPracticalExerciseAsset } from '../tracks/tracksUtils';
export const getMostRecentExamAttempt = (examId, trackProgress) => {
  var _trackProgress$examId, _trackProgress$examAt;
  if (!trackProgress) return undefined;
  const recentAttemptId = (_trackProgress$examId = trackProgress.examIdToRecentAttemptId) === null || _trackProgress$examId === void 0 ? void 0 : _trackProgress$examId[examId];
  const mostRecentExamAttempt = recentAttemptId ? (_trackProgress$examAt = trackProgress.examAttempts) === null || _trackProgress$examAt === void 0 ? void 0 : _trackProgress$examAt[recentAttemptId] : undefined;
  const examAttempts = trackProgress.examIdToRecentAttemptId ? Object.values(trackProgress.examIdToRecentAttemptId).map(attemptId => {
    var _trackProgress$examAt2;
    return (_trackProgress$examAt2 = trackProgress.examAttempts) === null || _trackProgress$examAt2 === void 0 ? void 0 : _trackProgress$examAt2[attemptId];
  }).filter(Boolean) : [];
  const latestExamAttempt = examAttempts && maxBy(examAttempts, attempt => {
    var _attempt$attemptFinis;
    return (_attempt$attemptFinis = attempt === null || attempt === void 0 ? void 0 : attempt.attemptFinishTime) !== null && _attempt$attemptFinis !== void 0 ? _attempt$attemptFinis : 0;
  });
  return mostRecentExamAttempt || latestExamAttempt || undefined;
};
export const getTrackPracticalExercises = lessons => {
  const practicalExercises = [];
  lessons.forEach(lesson => lesson.content.forEach(content => {
    if (isPracticalExerciseAsset(content)) {
      practicalExercises.push(Object.assign({}, content, {
        parentLesson: lesson
      }));
    }
  }));
  return practicalExercises;
};
export const getCanDoAllTrackPracticalExercises = trackPracticalExercises => {
  return !trackPracticalExercises.some(exercise => exercise.requiredAccess && exercise.requiredAccess.length || exercise.requiredProducts && exercise.requiredProducts.length);
};
export const getExamDeadline = (exam, mostRecentExamAttempt) => {
  if (!(exam !== null && exam !== void 0 && exam.durationMinutes) || !mostRecentExamAttempt) return null;
  return mostRecentExamAttempt.attemptStartTime + exam.durationMinutes * MS_IN_A_MINUTE;
};
export const getExamIsRecent = mostRecentExamAttempt => {
  if (!(mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.attemptFinishTime)) return false;
  return mostRecentExamAttempt ? getServerSyncedTime() - mostRecentExamAttempt.attemptFinishTime < 24 * 60 * 60 * 1000 : false;
};
export const getProbablyHasCert = (track, mostRecentExamAttempt, pendingPracticalExercises) => {
  return !!(track && (track.certification || !!track.exam) && mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed && pendingPracticalExercises && !pendingPracticalExercises.length);
};
export const getIsExamAttemptExpired = mostRecentExamAttempt => {
  const attemptExpiresOn = mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.attemptFinishTime ? mostRecentExamAttempt.attemptFinishTime + TRACK_AWARD_EXPIRY_DAYS * MS_IN_A_DAY : null;
  const isAttemptExpired = attemptExpiresOn ? new Date().getTime() > attemptExpiresOn : false;
  return {
    isAttemptExpired,
    attemptExpiresOn
  };
};
export const isExpired = expiresAt => {
  if (!expiresAt) return false;
  return expiresAt < Date.now();
};